<form #downloadFichaForm="ngForm">
    <app-custom-modal #modal [title]="title"
        [subtitle]="'Selecione as informações que deseja incluir na ficha do Paciente.'" (onCloseClick)="modal.close()"
        (onSaveClick)="download()" [saveLabel]="label" [buttonImage]="icon" [saveDisabled]="downloadFichaForm.invalid">
        <div class="container">
            <div class="d-flex flex-row" *ngFor="let grafico of opcaoGraficos.charts">
                <div class="col-auto">
                    <custom-togle (toggleChange)="updateList(grafico.type, $event)"></custom-togle>
                </div>
                <div class="col p-0">
                    <label class="form-label font-primary-gray-900">Dados de {{grafico.name}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-auto">
                    <custom-togle [(value)]="ficha.hasAlergia"
                        (toggleChange)="ficha.hasAlergia = $event"></custom-togle>
                </div>
                <div class="col p-0">
                    <label class="form-label font-primary-gray-900">Alergias</label>
                </div>
            </div>
            <div class="row">
                <div class="col-auto">
                    <custom-togle [(value)]="ficha.hasMedicamento"
                        (toggleChange)="ficha.hasMedicamento = $event"></custom-togle>
                </div>
                <div class="col p-0">
                    <label class="form-label font-primary-gray-900">Medicamentos</label>
                </div>
            </div>
        </div>
    </app-custom-modal>
</form>